import { UploadFileResponse } from 'api/premiumUserAPI/specialServicesAPI'
import { CallAPIAction, Status } from 'api/types'
import { GeneralFailResponse } from 'common/types/commonTypes'
import Actions from 'redux/actions'

type State = {
  fileKey: string
} & Status

const initialState: State = {
  fileKey: '',
  isLoading: false,
  success: false,
  fail: false,
}

export default (
  state: State = initialState,
  action: CallAPIAction<
    Actions.UPLOAD_SPECIAL_SERVICE_FILE_ASYNC,
    Actions.UPLOAD_SPECIAL_SERVICE_FILE_SUCCESS,
    Actions.UPLOAD_SPECIAL_SERVICE_FILE_FAIL,
    UploadFileResponse,
    GeneralFailResponse
  >,
) => {
  switch (action.type) {
    case Actions.UPLOAD_SPECIAL_SERVICE_FILE_ASYNC:
    case Actions.UPLOAD_SPECIAL_SERVICE_FILE_FAIL: {
      return {
        ...state,
        ...action.status,
      }
    }

    case Actions.UPLOAD_SPECIAL_SERVICE_FILE_SUCCESS:
      return {
        ...state,
        ...action.status,
        fileKey: action.payload.key,
      }

    default:
      return state
  }
}
